// src/pages/user/Contact.jsx
import React from 'react';
import ContactForm from '../../components/user/ContactForm';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaBuilding } from 'react-icons/fa';

const Contact = () => {
  const contactInfo = [
    {
      icon: FaPhone,
      title: 'Phone',
      details: ['+260 966 801 731'],
      link: 'tel:+260966801731'
    },
    {
      icon: FaEnvelope,
      title: 'Email',
      details: ['brasotech@gmail.com', 'brasotechinvestments@gmail.com'],
      link: 'mailto:brasotech@gmail.com'
    },
    {
      icon: FaMapMarkerAlt,
      title: 'Address',
      details: ['Kitwe', 'Zambia']
    },
    {
      icon: FaClock,
      title: 'Business Hours',
      details: ['Monday - Friday: 8:00 AM - 5:00 PM', 'Saturday: 9:00 AM - 1:00 PM', 'Sunday: Closed']
    }
  ];

  const departments = [
    {
      icon: FaBuilding,
      title: 'General Inquiries',
      email: 'brasotech@gmail.com or brasotechinvestments@gmail.com',
      phone: '+260 966 801 731'
    },
    {
      icon: FaBuilding,
      title: 'Sales Department',
      email: 'brasotech@gmail.com or brasotechinvestments@gmail.com',
      phone: '+260 966 801 731'
    },
    {
      icon: FaBuilding,
      title: 'Technical Support',
      email: 'brasotech@gmail.com or brasotechinvestments@gmail.com',
      phone: '+260 966 801 731'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-gray-900 text-white py-20">
        <div className="container-custom">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">Get in Touch</h1>
            <p className="text-xl text-blue-100">
              Contact us for engineering solutions, project inquiries, or partnership opportunities. 
              We're here to help you build excellence.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Contact Form */}
            <div className="lg:col-span-2">
              <ContactForm />
            </div>

            {/* Contact Information */}
            <div className="space-y-8">
              {/* Contact Cards */}
              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-md transition-shadow">
                    <div className="flex items-start space-x-4">
                      <div className="p-3 bg-blue-100 rounded-lg">
                        <info.icon className="h-6 w-6 text-blue-600" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-800 mb-2">{info.title}</h3>
                        <div className="space-y-1">
                          {info.details.map((detail, idx) => (
                            <p key={idx} className="text-gray-600">
                              {info.link && idx === 0 ? (
                                <a 
                                  href={info.link} 
                                  className="hover:text-blue-600 transition-colors"
                                >
                                  {detail}
                                </a>
                              ) : (
                                detail
                              )}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Departments */}
              <div className="bg-blue-50 rounded-xl p-6">
                <h3 className="font-semibold text-gray-800 mb-4 text-lg">Contact Departments</h3>
                <div className="space-y-4">
                  {departments.map((dept, index) => (
                    <div key={index} className="border-b border-blue-100 pb-4 last:border-0 last:pb-0">
                      <div className="flex items-center space-x-3 mb-2">
                        <dept.icon className="h-5 w-5 text-blue-600" />
                        <h4 className="font-medium text-gray-800">{dept.title}</h4>
                      </div>
                      <div className="space-y-1 ml-8">
                        <a 
                          href={`mailto:${dept.email}`}
                          className="text-sm text-gray-600 hover:text-blue-600 block"
                        >
                          {dept.email}
                        </a>
                        <a 
                          href={`tel:${dept.phone}`}
                          className="text-sm text-gray-600 hover:text-blue-600 block"
                        >
                          {dept.phone}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Bank Details */}
              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="font-semibold text-gray-800 mb-4">Our Official Banks</h3>
                <div className="space-y-3 text-sm">
                  <div>
                    <p className="font-medium text-gray-700">Indo Zambia Bank</p>
                    {/*<p className="text-gray-600">Account: 0082040000436</p>*/}
                   {/* <p className="text-gray-600">Name: Satech Motors Limited</p>*/}
                  </div>
                  <div>
                    <p className="font-medium text-gray-700">Zambia Industrial Commercial Bank</p>
                    {/*<p className="text-gray-600">Account: 1010014628003</p>*/}
                    {/*<p className="text-gray-600">Name: Satech Motors Limited</p>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Location</h2>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="h-96 bg-gray-200 flex items-center justify-center">
              {/* Replace with actual map embed */}
              <div className="text-center">
                <FaMapMarkerAlt className="h-16 w-16 text-blue-600 mx-auto mb-4" />
                <p className="text-gray-600">
                  Kitwe, Zambia
                </p>
                <p className="text-sm text-gray-500 mt-2">
                  Interactive map will be embedded here
                </p>
              </div>
            </div>
            <div className="p-6">
              <h3 className="font-semibold text-gray-800 mb-2">Office Location</h3>
              <p className="text-gray-600">
                Our headquarters are located in the heart of Kitwe, easily accessible from all major roads.
                We welcome visitors during business hours.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;